<template>
  <div class="sn-f-col-b-c ap">
    <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
      <div class="sn-f-s-c region">
        <div class="sn-f-s-c patient-title">
          <div class="required">*</div>
          <div>就诊人：</div>
        </div>
        <div v-if="!$sn.validate.array(patientList)" @click="handlePatientInfo();">
          暂未获取到就诊人，<span class="sn-pointer sn-fc-main">点击刷新</span>
        </div>
        <div v-else-if="patientList.length === 0" @click="navigateUrl('addition-patient');">
          暂无就诊人，<span class="sn-pointer sn-fc-main">点击添加</span>
        </div>
        <template v-else>
          <el-select class="name" :value="selectedPatient.patientId" @change="sendBackPatient">
            <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientList"></el-option>
          </el-select>
        </template>
      </div>
      <div class="sn-f-s-c region" v-if="selectedPatient.patientId">
        <div class="sn-f-s-c patient-title">
          <div class="required">*</div>
          <div>{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? '证件号' : '就诊卡' }}：</div>
        </div>
        <div v-if="!outCardSerial" @click="navigateUrl('addition-card');">
          {{ outCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
        </div>
        <div v-else>
          <el-input class="card" readonly="readonly" v-model="outCardSerialFormat"></el-input>
        </div>
      </div>
      <div class="sn-f-s-c region" v-if="selectedPatient.patientId && outCardSerial">
        <div class="sn-f-s-c patient-title">
          <div>当前可用余额：</div>
        </div>
        <div class="sn-fc-red1 sn-fw-bold">{{ outCardBalance === '--.--' ? outCardBalance : $sn.format.priceFormat(outCardBalance, 2) }}</div>
      </div>
      <div class="sn-f-c-c sn-pointer interaction"
      :class="{'sn-silence': !selectedPatient.patientId || !outCardSerial}" @click="getProjectInfo();">查询</div>
    </div>
    <div class="sn-f-1 ap-region" :class="{'sn-f-b-c': projectInfo.length > 0}">
      <template v-if="projectInfo.length > 0">
        <div class="sn-f-col-b-s project">
          <div class="ap-title">检查项目</div>
          <div class="sn-f-1 project-region">
            <div class="sn-f-s-c sn-pointer project-line"
            :class="{'interaction': project.projectId === $sn.format.getQuality(selected, 'project.projectId')}"
            :key="project.projectId" v-for="project in projectInfo" @click="goExchange('project', project);">
              <div class="iconfont" :class="{
                'icon-circle2yuanquan': project.projectId !== $sn.format.getQuality(selected, 'project.projectId'),
                'icon-xuanzhong sn-fc-main': project.projectId === $sn.format.getQuality(selected, 'project.projectId')
              }"></div>
              <div class="sn-f-1">{{ project.projectName }}</div>
            </div>
          </div>
        </div>
        <div class="sn-f-1 sn-f-col-b-c schedule" v-if="$sn.format.getQuality(selected, 'project.projectId')">
          <div class="schedule-region">
            <div class="ap-title">{{ $sn.format.getQuality(selected, 'project.projectName') }}</div>
            <template v-if="scheduleInfo.length > 0">
              <div class="sn-table">
                <table>
                  <thead>
                    <tr>
                      <th :key="date.date" v-for="date in scheduleInfo">
                        <div>{{ $sn.format.date(new Date(date.date), 'MM-dd') }}</div>
                        <div>周{{ $sn.format.day(date.date) }}</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td :key="date.date" v-for="date in scheduleInfo">
                        <div class="sn-f-col-b-s sn-pointer schedule-line"
                        :class="{'sn-silence': parseInt(schedule.total) - parseInt(schedule.remind) <= 0}"
                        :key="date.date + schedule.roomId" v-for="schedule in date.schedule" @click="goExchange('schedule', {
                          date: date.date,
                          ...schedule
                        });">
                          <div>{{ schedule.roomName }}</div>
                          <div class="sn-f-e-c sub">
                            余号：<span>{{ parseInt(schedule.total) - parseInt(schedule.remind) }}</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <template v-if="$sn.format.getQuality(selected, 'schedule.roomId')">
                <div class="ap-title">
                  {{ $sn.format.getQuality(selected, 'schedule.date') }}
                  &nbsp;/&nbsp;
                  {{ $sn.format.getQuality(selected, 'schedule.roomName') }}
                </div>
                <div class="sn-f-s-c sn-f-wrap period" v-if="periodInfo.length > 0">
                  <div class="sn-f-s-0 sn-f-c-c sn-pointer period-line"
                  :class="{'interaction': period.planId === $sn.format.getQuality(selected, 'period.planId')}"
                  :key="period.planId" v-for="period in periodInfo" @click="goExchange('period', period);">{{ period.time }}</div>
                </div>
                <sn-no-data v-else></sn-no-data>
              </template>
            </template>
            <sn-no-data v-else></sn-no-data>
          </div>
          <div class="sn-f-s-0 sn-f-c-c sn-pointer schedule-interaction"
          :class="{'sn-silence': disabled}" @click="goAppointment();">确认预约</div>
        </div>
      </template>
      <sn-no-data v-else></sn-no-data>
    </div>
    <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
    <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" @sendBack="sendBackBindCard"></bind-card>
  </div>
</template>
<script type="text/javascript">
import { orderConfig, gatherConfig } from '@/common/utils/function-config';
import Swagger from '@/common/utils/swagger';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import * as Messages from '@/common/utils/messages';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import * as ServiceConfig from '@/common/utils/service-config.js';

export default {
  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  mixins: [HomepageMixin],
  data() {
    return {
      patientList: [],
      selectedPatient: {},
      outCardSerial: '',
      outCardSerialFormat: '',
      outCardBalance: '--.--',
      projectInfo: [],
      scheduleInfo: [],
      periodInfo: [],
      selected: {},
      //
      exhibitionCreatePatient: false,
      //
      exhibitionBindCard: false
    };
  },
  computed: {
    disabled() {
      if (this.$sn.validate.empty(this.selectedPatient) || !this.selectedPatient.patientId) return true;
      if (this.$sn.validate.empty(this.selected)) return true;
      if (this.$sn.validate.empty(this.selected.project) || !this.selected.project.projectId) return true;
      if (this.$sn.validate.empty(this.selected.schedule) || !this.selected.schedule.roomId) return true;
      if (this.$sn.validate.empty(this.selected.period) || !this.selected.period.planId) return true;
      return false;
    }
  },
  watch: {
    selectedPatient: async function(patient) {
      this.outCardSerial = '';
      this.outCardSerialFormat = '';
      this.outCardBalance = '--.--';
      this.projectInfo = [];
      this.scheduleInfo = [];
      this.periodInfo = [];
      this.selected = {};
      if (patient.patientId) {
        this.$sn.assembly.loading(true);
        const handle = await Tools.handlePatientInfo(patient);
        this.$sn.assembly.loading(false);
        if (handle.code >= 0) {
          this.outCardSerial = handle.data.no;
          this.outCardSerialFormat = handle.data.caption;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && handle.code === 0) {
            this.outCardSerialFormat = patient.idCardEncrypt;
          }
        }
        if (this.outCardSerial) {
          this.getOutCardBalance();
        }
        else {
          const compare = {
            [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
          };
          this.$sn.assembly.modal({
            caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
            success: (modal) => {
              if (modal.confirm) {
                this.navigateUrl('addition-card');
              }
            }
          });
        }
      }
    }
  },
  created: function() {
    this.handlePatientInfo();
  },
  methods: {
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      if (this.patientList && this.patientList.length > 0) {
        this.selectedPatient = this.$sn.utils.getCurrentPatient();
      }
    },
    getOutCardBalance() {
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: Swagger.getCardBalance,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          bindType: this.$sn.utils.getPlatformType(),
          cardNo: this.outCardSerial,
          clinicType: this.perpetual.OUT_CARD_CLINIC_TYPE,
          hosArea: '',
          hosId: this.$sn.utils.getHospitalId(),
          idCardNo: '',
          openId: this.$sn.utils.getOpenId(),
          patName: '',
          patientId: this.selectedPatient.patientId,
          reservedDate: '',
          state: ''
        })
      }).then(result => {
        this.$sn.assembly.loading(false);
        this.outCardBalance = '--.--';
        if (result) {
          if (result.code === 0) {
            if (result.data) {
              this.outCardBalance = result.data.cardBalance;
            }
            else {
              this.$sn.assembly.modal({
                caption: Messages.RECHARGE010,
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: Messages.RECHARGE010,
              isCancel: false
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C001,
            isCancel: false
          });
        }
      });
    },
    getProjectInfo() {
      this.projectInfo = [];
      this.scheduleInfo = [];
      this.periodInfo = [];
      this.selected = {};
      if (!this.selectedPatient.patientId || !this.outCardSerial) return false;
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), 'a0b33d97-7256-40fc-b632-c4ff7ec1bd3b']),
        method: 'POST',
        header: true,
        data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
          PatId: this.selectedPatient.patientId,
          PlatformId: this.$sn.utils.getPlatformType(),
          PlatformUserId: this.$sn.utils.getOpenId()
        }))
      }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (result.data) {
              if (result.data.ResultCode === '0') {
                if (result.data.Data && result.data.Data.length > 0) {
                  this.projectInfo = result.data.Data;
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: result.data.ResultMsg,
                  isCancel: false
                });
              }
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: result.msg,
              isCancel: false
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C001,
            isCancel: false
          });
        }
      });
    },
    goExchange(key, item) {
      this.selected[key] = item;
      if (key === 'project') {
        this.scheduleInfo = [];
        this.periodInfo = [];
        this.$set(this.selected, 'schedule', {});
        this.$set(this.selected, 'period', {});
        if (item.projectId) {
          this.$sn.assembly.loading(true);
          this.$sn.utils.ordinaryRequest({
            url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), 'bfb52112-8227-448e-959c-036f4b18a201']),
            method: 'POST',
            header: true,
            data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
              HosProjectId: item.projectId,
              HosProjectName: item.projectName,
              PatId: this.selectedPatient.patientId,
              PlatformId: this.$sn.utils.getPlatformType(),
              PlatformUserId: this.$sn.utils.getOpenId()
            }))
          }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
            this.$sn.assembly.loading(false);
            if (result) {
              if (result.code === 0) {
                if (result.data) {
                  if (result.data.ResultCode === '0') {
                    if (result.data.Data && result.data.Data.length > 0) {
                      for (let i = 0; i < 7; i++) {
                        const date = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', i, 'day');
                        const match = result.data.Data.find(res => res.date === date);
                        this.scheduleInfo.push({
                          date: date,
                          status: !this.$sn.validate.empty(match) && match.canBook === 'Y' ? '1' : '0',
                          schedule: !this.$sn.validate.empty(match) && !this.$sn.validate.empty(match.detail) ? match.detail : []
                        });
                      }
                      this.scheduleInfo = this.$sn.format.digitalSort(this.scheduleInfo, '1', 'date');
                    }
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: result.data.ResultMsg,
                      isCancel: false
                    });
                  }
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: result.msg,
                  isCancel: false
                });
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: Messages.C001,
                isCancel: false
              });
            }
          });
        }
      }
      else if (key === 'schedule') {
        this.periodInfo = [];
        this.$set(this.selected, 'period', {});
        if (item.roomId && parseInt(item.total) - parseInt(item.remind) > 0) {
          this.$sn.assembly.loading(true);
          this.$sn.utils.ordinaryRequest({
            url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), 'd38465f7-cc72-4f5b-8650-099a00458959']),
            method: 'POST',
            header: true,
            data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
              HosProjectId: this.selected.project.projectId,
              HosProjectName: this.selected.project.projectName,
              PatId: this.selectedPatient.patientId,
              PlatformId: this.$sn.utils.getPlatformType(),
              PlatformUserId: this.$sn.utils.getOpenId(),
              RegDate: item.date,
              RoomId: item.roomId
            }))
          }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
            this.$sn.assembly.loading(false);
            if (result) {
              if (result.code === 0) {
                if (result.data) {
                  if (result.data.ResultCode === '0') {
                    if (result.data.Data && result.data.Data.length > 0) {
                      this.periodInfo = this.$sn.format.digitalSort(result.data.Data, '1', 'time');
                    }
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: result.data.ResultMsg,
                      isCancel: false
                    });
                  }
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: result.msg,
                  isCancel: false
                });
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: Messages.C001,
                isCancel: false
              });
            }
          });
        }
      }
    },
    goAppointment() {
      if (this.disabled) return false;
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), 'e8c8b0fb-32c9-430f-afee-23b86f69302a']),
        method: 'POST',
        header: true,
        data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
          HosProjectId: this.selected.project.projectId,
          HosProjectName: this.selected.project.projectName,
          PatId: this.selectedPatient.patientId,
          PlanId: this.selected.period.planId,
          PlatformId: this.$sn.utils.getPlatformType(),
          PlatformUserId: this.$sn.utils.getOpenId(),
          RegDate: this.selected.schedule.date,
          RoomId: this.selected.schedule.roomId,
          Time: this.selected.period.time
        }))
      }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (result.data) {
              if (result.data.ResultCode === '0') {
                let msg = this.$sn.format.caption(Messages.C016, ['预约']);
                if (result.data.Data && result.data.Data.notice) {
                  msg += '，' + result.data.Data.notice;
                }
                this.$sn.assembly.toast({
                  caption: msg,
                  mode: 'success',
                  success: () => {
                    const order = orderConfig();
                    const match = order.find(res => res.id === this.perpetual.FUNCTION_ID_YJYY);
                    this.navigateUrl(match.url, match, match.params);
                  }
                });
              }
              else {
                this.$sn.assembly.modal({
                  caption: result.data.ResultMsg,
                  isCancel: false,
                  success: (modal) => {
                    if (modal.confirm) {
                      if (result.data.ResultCode === '13') {
                        const gather = gatherConfig();
                        const match = gather.find(res => res.id === this.perpetual.FUNCTION_ID_MZCZ);
                        this.navigateUrl(match.url, match, match.params);
                      }
                    }
                  }
                });
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: this.$sn.format.caption(Messages.C017, ['预约']),
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: result.msg,
              isCancel: false
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C001,
            isCancel: false
          });
        }
      });
    },
    sendBackPatient(id) {
      if (id) {
        this.selectedPatient = this.patientList.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    sendBackCreatePatient(type) {
      if (type) {
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionCreatePatient = false;
    },
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'addition-patient') {
        this.exhibitionCreatePatient = true;
      }
      else if (url === 'addition-card') {
        this.exhibitionBindCard = true;
      }
      else this.homepage_mixin_navigateUrl(url, item, params, type);
    }
  }
};
</script>
<style lang="scss" scoped>
.ap {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    width: 100%;

    .ap-title {
      @include fs(20);

      font-weight: bold;
      color: $text1;
      margin-bottom: 10px;
    }

    .project {
      width: 20%;
      height: 100%;
      border-right: 1px solid $border1;

      &-region {
        overflow-x: hidden;
        overflow-y: auto;
        width: 100%;
        padding-right: 10px;

        .project-line {
          @include fs(16);

          overflow: hidden;
          width: 100%;
          color: $text1;
          border: 1px solid $border1;
          border-radius: 8px;
          padding: 10px;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }

          &.interaction {
            font-weight: bold;
            color: $main;
            border: 1px solid $main;
          }

          .iconfont {
            font-size: 20px;
            font-weight: normal;
            color: $text6;
            margin-right: 10px;
          }
        }
      }
    }

    .schedule {
      height: 100%;
      margin-left: 10px;

      &-region {
        overflow-x: hidden;
        overflow-y: auto;
        width: 100%;

        .sn-table {
          margin-bottom: 10px;

          td {
            @include fs(14);

            .schedule-line {
              border-bottom: 1px solid $border1;
              padding: 5px 0;

              &:first-child {
                padding-top: 0;
              }

              &:last-child {
                border-bottom: none;
                padding-bottom: 0;
              }

              .sub {
                @include fs(12);

                width: 100%;
                color: $text3;

                span {
                  font-weight: bold;
                  color: $main;
                }
              }
            }
          }
        }

        .period {
          overflow: hidden;
          width: 100%;

          &-line {
            @include fs(16);

            flex: 0 0 calc((100% - 30px) / 4);
            height: 40px;
            color: $text1;
            border: 1px solid $border1;
            border-radius: 8px;
            margin-right: 10px;
            margin-bottom: 5px;

            &:nth-child(4n+4) {
              margin-right: 0;
            }

            &.interaction {
              background-color: $main;
              color: $white;
              border: 1px solid $main;
            }
          }
        }
      }

      &-interaction {
        @include fs(16);

        overflow: hidden;
        width: 200px;
        height: 40px;
        background-color: $main;
        color: $white;
        border-radius: 8px;
        margin-top: 10px;
      }
    }
  }
}
</style>
